<template>
  <div
    :id="props.project.id"
  	v-if="!props.isprintView"
    ref="projectEl"
    class="sidebar-group"
    :class="{ open: props.isopen }"
    :style="sidebarGroupStyle"
    @click="emit('update', props.project.id)"
  >
    <div class="flex items-center justify-between w-full px-2">
      <div class="flex items-center gap-2">
        <ChevronRight :size="16" v-if="!props.isopen"/>
        <ChevronDown  :size="16" v-if="props.isopen"/>
        {{ props.project.name }}
      </div>

      <div v-show="props.isopen" class="flex items-center">
        <Button variant="ghost" size="icon" @click.stop="showPersonModal = true">
          <Filter :size="16" :class="{ 'text-timin': hasOwnFilter }" />
        </Button>
        <Button variant="ghost" size="icon" @click.stop="activePrintMenu = !activePrintMenu">
          <Printer :size="16"/>
        </Button>
      </div>
    </div>

    <PersonSelectionModal
      :open="showPersonModal"
      :project="props.project"
      :users="props.users"
      :bookings="props.bookings"
      :projects="props.projects ?? []"
      :resourceFilter="props.resourceFilter.filter"
      @apply="(filter) => { emit('updateResourceFilter', props.project.id, filter); showPersonModal = false }"
      @cancel="showPersonModal = false"
    />

    <PrintCallout
      :id="`print-${props.project.id}`"
      :target="projectEl"
      :show="activePrintMenu"
      :project="props.project"
	    @close="activePrintMenu = false"
      @print-view="handlePrintAction"
    />
  </div>

  <div v-if="props.isopen">
    <div v-for="(u, idx) in filteredUsers" :key="u.id" :style="userRowStyle(idx)" class="content" :class="{printview: props.isprintView}">
      <div class="inner">{{ u.firstname }} {{ props.isprintView ? u.lastname : u.short }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { getRowHeight, applyResoureFilter } from "./planner.js"
import PersonSelectionModal from './PersonSelectionModal.vue'
import PrintCallout from './PrintCallout.vue'
import { Button } from "@/components/ui/button"
import { ChevronRight, ChevronDown, Printer, Filter } from "lucide-vue-next"

const props = defineProps(['project', 'users', 'bookings', 'isopen', 'resourceFilter', 'isprintView', 'projects'])
const emit = defineEmits(['update', 'updateResourceFilter', 'printView'])

const projectEl = ref(null)
const activePrintMenu = ref(false)
const showPersonModal = ref(false)

const filteredUsers = computed(() =>
  props.users.filter((u: any) => applyResoureFilter(props.resourceFilter, props.project, u))
)

// Hinweis am Filtersymbol, wenn hier ein eigener Personenfilter aktiv ist —
// Björns Wunsch aus dem Mai-Thread in TIM-18.
const hasOwnFilter = computed(() => props.resourceFilter.filter?.mode === 'custom')

const sidebarGroupStyle = computed(() => ({ height: `${getRowHeight(props.isprintView)}px` }))

function userRowStyle(_idx: number | string) {
  return { height: `${getRowHeight(props.isprintView)}px` }
}

function handlePrintAction(start: string, end: string) {
    emit('printView', props.project, start, end);
}
</script>

<style scoped>

.sidebar-group {
  border: 1px solid #ccc;
  overflow: hidden;
  transition: height 0.3s ease;
  display: flex;
}

.sidebar-group.spacer {
  background-color: rgb(250, 250, 250);
}

.content {
  padding: 8px;
  background: #fff;
}

.content.printview {
  display: flex;
  align-items: self-end;
  padding-left: 10px;
  height: 100%;
  font-size: 12px;
  border-bottom: 1px solid rgb(229 231 235 / var(--tw-border-opacity, 1)) !important;
}

.toggle {
  font-size: 0.8em;
}

</style>
